export default "/_next/static/images/54de8cfea6060b93d7d0857c6c1d20be.png";